export default __webpack_public_path__ + "assets/images/7d7c73759f9c8c991b2daa425391424b.png";